import { Activity } from '../../types/GrooverTypes'

export enum GtmRegistrationEvent {
  Booking = 'booking',
  BookingPaid = 'booking_paid'
}

export type GtmActivityMetadata = {
  id: string
  name: string
  type: Activity['type']
  period: string
  startDate: string
  style: string
  place?: string
  city?: string
  price: number
}

export type GtmBookingPayload = {
  event: GtmRegistrationEvent
  eventId: string
  currency: string
  value: number
  activity: GtmActivityMetadata
  activities?: GtmActivityMetadata[]
}
